import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Main } from '../../../../constant';
import { Input } from '../../../../components/input/input';
import { Box, Checkbox, Chip, FormControlLabel, FormGroup, Grid, Stack, Typography , Fade } from '@mui/material';
import { Link } from 'react-router-dom';
import RadioButn from '../../../../components/radioButn/radioButn';
import { CustomBtn } from '../../../../components/button/button';
import CustomForm from '../../../../components/form/form';
import { useDispatch, useSelector } from 'react-redux';
import { TeacherRegistation } from '../../../../redux/actions/registration/teacherregistation';
import { DateGlobalConvertor } from '../../../../components/Date/DateGlobalConverter'
import dayjs from 'dayjs';
import { PostRequest } from '../../../../redux/actions/PostRequest';
import { GetRequest } from '../../../../redux/actions/GetRequest';
import { StoreTable } from './storetable';

const Auth = (props) => {
    const [data , setData] = useState(Main().BuyProducts);
    const [storedata , setStoredata ] = useState()
    const [formKey, setFormKey] = useState(0);
    const dispatch = useDispatch()
    const api = useSelector((state)=>state.Api);
    const getfilterdata =  data.inputs.filter((item) => item.feildtype !== 'label');
    const [loadDate, setLoadDate] = useState(DateGlobalConvertor(dayjs(Date.now())))
    const userToken = JSON.parse(sessionStorage.getItem("User_Data")).token
    //console.log(loadDate)
    const initialInputValues = Object.fromEntries(
        getfilterdata
            .map((item) => [item.name, ''])
    );

    const [inputValues, setInputValues] = useState(initialInputValues);

    
    const[ butnVisiablity , setButnVisiablity] = useState(true)


    function handleInputChange(e) {
        if (inputValues.AdmissionDate === '') { 
            updateAdmDate()
        }
        //console.log(inputValues )
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
        }));
    }
    
    function handleRadioChange(e) {
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.placeholder,
        }));
    }
    

    async function myfunc(event) {
        event.preventDefault();
        
        console.log(inputValues)
        // return false
        // //console.log(JSON.parse(sessionStorage.getItem("User_Data")).token);
        await setButnVisiablity(false)
        await dispatch(TeacherRegistation(api.Bookinsert,  userToken , inputValues))
        setTimeout(()=>{
            refreshForm()
            setInputValues(initialInputValues)
            setButnVisiablity(true)
        },1000)
    }
    function updateAdmDate(){
        setInputValues((prevValues) => ({
            ...prevValues,
            'AdmissionDate': loadDate.formatNormalDate,
            'admGrDate': loadDate.gregorianDate,
            'admArDate': loadDate.arabicDate,
        }));
    }

    const ChangeDate = (e, name, grDate, arDate) => {
        const grDateConst = name != 'DOB' ? 'admGrDate' : 'dobGrDate';
        const arDateConst = name != 'DOB' ? 'admArDate' : 'dobArDate';
        setInputValues((prevValues) => ({
            ...prevValues,
            [name]: e,
            [grDateConst]: grDate,
            [arDateConst]: arDate
        }));
    }
const ChangeOnSelect = (getparam) => {
    setInputValues((oldData)=> ({
        ...oldData,
        [getparam[1]]:getparam[0]
    })
    )
    //console.log(inputValues)
}

 // Function to refresh the form
 const refreshForm = () => {
    setFormKey(prevKey => prevKey + 1);
}

const loadData = async() => {
    const res = await dispatch(GetRequest(api.Bookget , userToken , ""  ))
    setStoredata(res.data)
    console.log(res.data)
    return res
}
useEffect(()=>{
    const getdata = loadData();
    console.log(getdata)
},[])

    return (
        <form onSubmit={myfunc}>
            <Grid container>
            <CustomForm key={formKey} data={data.inputs} ChangeOnSelect={ChangeOnSelect} ChangeDate={ChangeDate}  handleRadioChange={handleRadioChange} handleInputChange={handleInputChange}  />
            </Grid>
            
            <Grid container mt={1}>
                <Grid item md={12} lg={12} >
                    <Box>
                        <CustomBtn disable={!butnVisiablity} data={data.butn} style={{maxWidth:'600px' , margin:'auto',display:'block' , marginTop:'10px'}} />
                    </Box>
                </Grid>

                <Grid item md={12} lg={12}>
                {inputValues.PurchasePrice && inputValues.Quantity ? (
                    <Fade in timeout={400}>
                    <Chip
                        label={`Total: ${(
                        Number(inputValues.PurchasePrice) *
                        Number(inputValues.Quantity)
                        ).toLocaleString()}`}
                        sx={{
                        background: "linear-gradient(135deg, #4CAF50, #2E7D32)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "15px",
                        px: 2,
                        py: 2,
                        borderRadius: "20px",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                            transform: "scale(1.05)",
                            boxShadow: "0 8px 22px rgba(0,0,0,0.2)",
                        },
                        }}
                    />
                    </Fade>
                ) : null}
                </Grid>

            </Grid>
            <StoreTable data={storedata} />
        </form>
    );
};

Auth.propTypes = {};

export default Auth;


